import * as PIXI from 'pixi.js'
import vertSrc from './shaders/payline.vert?raw'
import fragSrc from './shaders/payline.frag?raw'

export class PaylineMaterial extends PIXI.Shader {
    public constructor(texture: PIXI.Texture) {
        const glProgram = new PIXI.GlProgram({
            vertex: vertSrc,
            fragment: fragSrc,
        })

        const textureSource = texture?.source ?? PIXI.Texture.WHITE.source

        super({
            glProgram,
            resources: {
                uTexture: textureSource,
            },
        })
    }
}
